import React, { useState } from "react";
import stepsData1 from "../layout/stepsData1";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";

const UserJourney1 = ({setShowIntro1}) => {
  const [stepsEnabled, setStepsEnabled] = useState(true);
  const [initialStep, setInitialStep] = useState(0);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setInitialStep(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStepsEnabled(false);
      setShowIntro1(false);
      localStorage.setItem("introShown1", true);
    }
  };

  const steps = stepsData1

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        steps={steps}
        continuous
        scrollToFirstStep
        showSkipButton
        run={stepsEnabled}
        stepIndex={initialStep}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        locale={{
          last: "Finish",
        }}
        disableOverlayClose
        disableScrolling
        disableCloseOnEsc
        disableScrollParentFix
      />
    </>
  );
};

export default UserJourney1;
